import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import select from 'scoreboard-select'
import template from './user-list-filter.hbs'

var UserListFilter = Backbone.View.extend({

	events: {
		'change .field': '_onField',
		'change .sort-by': '_onSort'
	},

	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		var context = {}
		this.$el.empty().append(template(context))

		this.typeDropdown = this.$('select.field')
		this.typeDropdown.append(new Option(
			i18n.get('common.everything'),
			this.options.allFields))

		_.each(this.options.fields, field => this.typeDropdown.append(
				new Option(i18n.get(`common.user.${field}`), field)))

		this.typeDropdown.val(this.options.fieldName)

		this._onField()
		select(this.el.querySelectorAll('select'))

		return this
	},

	_onField: function () {
		const field = this.typeDropdown.val()
		this.trigger('field', field)
		let isSortByText = field !== 'id'
		let sortType = isSortByText ? 'text' : 'number'
		this.$('.sort-by').val(this.options.sortDirection)
		this.sortDropdown = this.$(`.sort-by.${sortType}`)
		this.sortDropdown.removeClass('is-not-displayed')
		this.$(`.sort-by:not(.${sortType})`).addClass('is-not-displayed')
		// Make sure if sort type changes, the sorting matches it
		this._onSort()
	},

	_onSort: function () {
		let sortDropdownVal =  this.sortDropdown.val()
		this.trigger('sort', sortDropdownVal)
	}
})

export default UserListFilter

UserListFilter.__filename__ = 'admin/principals/users/user-list-filter.js'
